import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { getListProveedor } from "../api/api-equipment-provider";
// import "react-widgets/styles.css";
// import DatePicker from "react-widgets/DatePicker";
import moment from "moment";
// import momentLocalizer from "react-widgets-moment";

// new momentLocalizer(moment);

export default function ModalFormEquipo({ title, formData, setFormData, isOpen, onCancel, onConfirm }) {

    const { t } = useTranslation();
    const dateInputRef = useRef(null);
    const [list, setList] = useState([]);
    const [proveedorSelected, setProveedorSelected] = useState(null);
    const [fechaAdquisicion, setFechaAdquisicion] = useState("");

    // useEffect(() => {
    //     const userDate = moment().format("YYYY/MM/DD"); // Get user date in YYYY/MM/DD
    //     setFechaAdquisicion(userDate);
    // }, []);

    useEffect(() => {
        iniciar();
    }, [formData]);

    const iniciar = async () => {
        try {
            // console.log('formData');
            // console.log(formData);
            const lista = await getListProveedor({ habilitado: 1 }, true, t);
            setList(lista);
            if (formData.idProveedor !== null) {
                const operador = lista.find(e => e.value === formData.idProveedor);
                // console.log('operador');
                // console.log(operador);
                setProveedorSelected(operador);
            }
            if (formData.fechaAdquisicion !== undefined && formData.fechaAdquisicion !== null && moment(formData.fechaAdquisicion).isValid() === true) {
                setFechaAdquisicion(moment(formData.fechaAdquisicion).format('YYYY-MM-DD'));
            }
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
        }
    };

    const charLimits = {
        idEquipo: 128,
        modelo: 128,
        // estado: 64,
        codImportacion: 32,
        imei: 36,
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (value.length <= charLimits[name]) {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const validateForm = () => {
        try {
            // console.log('validateForm');
            // console.log(fechaAdquisicion);
            // console.log("proveedorSelected", proveedorSelected);
            let message = "";
            if (String(formData.idEquipo).trim().length === 0) {
                message = message + t("alert_must_enter_device_id") + '\n';
            }
            if (String(formData.modelo).trim().length === 0) {
                message = message + t("alert_must_enter_model") + '\n';
            }
            // if (String(formData.estado).trim().length === 0) {
            //     message = message + t("alert_must_enter_status") + '\n';
            // }
            // if (String(fechaAdquisicion).trim().length === 0) {
            //     message = message + t("alert_must_enter_purchase_date") + '\n';
            // }
            if (moment(fechaAdquisicion).isValid() === false) {
                message = message + t("alert_invalid_date") + '\n';
            }
            if (proveedorSelected === null || proveedorSelected === undefined) {
                message = message + t("alert_must_select_tracking_device_provider") + '\n';
            }
            if (message.length > 0) {
                alert(message);
                return;
            }
            formData.fechaAdquisicion = moment(fechaAdquisicion).format("YYYY/MM/DD");
            formData.idProveedor = proveedorSelected.value;
            onConfirm(formData);
        } catch (err) {
            console.log('validateForm err');
            console.log(err);
        }
    };

    const cancelForm = () => {
        setFormData({
            ...formData,
            id: 0,
            idEquipo: "",
            modelo: "",
            // estado: "",
            codImportacion: "",
            idProveedor: null,
            imei: "",
        });
        setProveedorSelected(null);
        onCancel();
    }

    return (
        <>
            {isOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-1/3">
                        <h2 className="text-xl font-bold mb-4 text-gray-700">{title}</h2>

                        {/* Inputs */}
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("id_equipo")}/ESN<span className="text-red-500">*</span></label>
                            <input
                                name="idEquipo"
                                value={formData.idEquipo}
                                onChange={handleInputChange}
                                placeholder={t("enter_id_equipo")}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.idEquipo.length}/{charLimits.idEquipo}</p>
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("model")}<span className="text-red-500">*</span></label>
                            <input
                                name="modelo"
                                value={formData.modelo}
                                onChange={handleInputChange}
                                placeholder={t("model")}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.modelo.length}/{charLimits.modelo}</p>
                        </div>
                        {/* <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("status")}<span className="text-red-500">*</span></label>
                            <input
                                name="estado"
                                value={formData.estado}
                                onChange={handleInputChange}
                                placeholder={t("status")}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.estado.length}/{charLimits.estado}</p>
                        </div> */}
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("date_purchase")}: MM/DD/YYYY<span className="text-red-500">*</span></label>
                            <div
                                className="relative w-full cursor-pointer"
                                onClick={() => dateInputRef.current?.showPicker()} // Open calendar on click
                            >
                                <input
                                    type="date"
                                    ref={dateInputRef}
                                    value={fechaAdquisicion}
                                    onChange={(e) => {
                                        console.log('date:', e.target.value);
                                        setFechaAdquisicion(e.target.value);
                                    }}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">IMEI</label>
                            <input
                                name="imei"
                                value={formData.imei}
                                onChange={handleInputChange}
                                placeholder={"IMEI"}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.imei.length}/{charLimits.imei}</p>
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("device_provider")}<span className="text-red-500">*</span></label>
                            <Select
                                options={list}
                                isSearchable={true}
                                isClearable={true}
                                value={proveedorSelected}
                                onChange={(event) => setProveedorSelected(event)}
                                placeholder={t("label_select_provider")}
                                className="w-full"
                                menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{"Code Imp"}</label>
                            <input
                                name="codImportacion"
                                value={formData.codImportacion}
                                onChange={handleInputChange}
                                placeholder={"Code Imp"}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.codImportacion.length}/{charLimits.codImportacion}</p>
                        </div>

                        {/* Buttons */}
                        <div className="flex justify-end gap-4">
                            <button
                                onClick={cancelForm}
                                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500 transition duration-300"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={validateForm}
                                className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition duration-300"
                            >
                                Acceptar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );

}
